module.exports = __webpack_public_path__ + "img/model-layer.2c4cd333.svg";